import React from "react";

const Error = ({ message }) => (
  <div className="alert alert-danger my-2">{message}</div>
);

export default Error;
